<template>
  <div :id="this.containerId" >

    <div v-html="this.viewerText" class="_viewer"> </div>

     <!-- <quill-editor 
    class="text-gray-900 dark:text-gray-50"
      ref="myQuillViewer"
      theme="bubble"
      :content="contentViewer"
      :options="editorOption"
      />

     <ExternalLinkClicked
        v-if="this.externalLinkClicked != ''"
        :link="this.externalLinkClicked"
      /> -->
  </div>
</template>

<script>

//import ExternalLinkClicked from '@/components/ExternalLinkClicked.vue'
import { v4 as uuidv4 } from 'uuid'
import { QuillEditor } from '@vueup/vue-quill'
import { quill } from 'quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@vueup/vue-quill/dist/vue-quill.bubble.css';

  export default {
  props: ["viewerText"],
  components: {
    quill, QuillEditor//, ExternalLinkClicked
  },
    data () {
      return {
        contentViewer: this.viewerText,
        editorOption: {
          toolbar: false,
          readOnly: true,
          class: "123",
        },
        externalLinkClicked: "",
        containerId: "div_" + uuidv4()
      }
    },
    computed: {
      editor() {
       return this.$refs.myQuillViewer
      }
    },
    mounted() {

      //this.content = this.viewerText;
      // if (this.viewerText != ''){
      //   this.editor.setHTML(this.viewerText);
      // }

      const editorEl = document.getElementById(this.containerId);
      editorEl.addEventListener('click', (e) => {
        this.handleExternalLinkClick(e);
      });
    },
      methods: {
        handleExternalLinkClick(e){
          const link = e.target.closest('a');
          if (!link) 
          {
            return;
          }
          e.preventDefault(); // optional
          if(confirm("External link clicked, you are about to open a link to: \n\n" + link.href + "\n\nDo you want to proceed?"))
          {
            window.open(link.href, "_blank");       
          }
        }
      }
  }
</script>

<style>

  ._viewer {
    color: rgb(116 120 141 / var(--tw-text-opacity)) !important;
    --tw-text-opacity: 1 !important;
    font-family: Inter, sans-serif;
    font-size: 14px;
  }

._viewer strong {
    color: #0099FF;
    font-size: 14px;
    /* padding-bottom: 15px; */
        display:inline !important;

  }

  ._viewer > p {
    /* color: rgb(116 120 141 / var(--tw-text-opacity)) !important; */
    padding: 5px;
  }

    ._viewer > span {
    font-size: 14px;
    /* padding-bottom: 15px; */
  }

  ._viewer > h1 {
    color: #b3b5c1;
    padding-bottom: 10px;
  }


  ._viewer > h2 {
    color: #b3b5c1;
    font-size: 16px;
    padding-bottom: 10px;
  }

  ._viewer > h3 {
    color: #b3b5c1;
    font-size: 15px;
    padding-bottom: 15px;
    padding-top: 15px;
  }

  ._viewer > h4 {
    color: #b3b5c1;
    font-size: 14px;
    padding-top: 15px;
    padding-bottom: 15px;
    /* padding-bottom: 15px; */
  }

    ._viewer > ul {
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 25px;
    padding-left: 25px;
    list-style-type: circle;
        

    /* padding-bottom: 15px; */
  }

  ::marker {
  color: #0099FF !important;
}
  ._viewer > li {
    /* color: rgb(116 120 141 / var(--tw-text-opacity)) !important; */
    font-size: 14px;
    padding: 16px;

  }

    /* .ql-editor > li > p {
    padding: 0px;

  }

      .ql-editor > li > ul > li > p {
    padding: 0px;

  }*/

  ._viewer > ul > li > p {
    padding: 0px;
  } 

  
  ._viewer > img  {
    width: 40%;
    float: left;
    margin-right: 12px;
    margin-top: 20px;
    max-height: 200px;
  }

  ._viewer{
    padding: 0px!important;
  }
</style>